<app-simple-modal [title]="'Crear Solicitud de Empresa'" (close)="close.emit($event)">
	<div fields>
		<app-company-request [newCompany]="newCompany"></app-company-request>
		<hr>
		<div class="row">
			<div class="col">
				<h5>Datos de la reunión</h5>
				<div class="form-group">
					<label for="user" class="form-label">Encargado <i class="fa fa-asterisk text-danger"></i></label>
					<div class="input-group">
						<app-input-autocomplete (changeStatus)="selectUser($event.filterElement)"
						(inputMethod)="searchUser()" [allBorderRadius]="true" [filterElements]="users"
						[placeholder]="'Busca una usuario'" [custom]="true" [inputs]="inputs">
						<ng-template #itemsTemplate let-filter>
							<!-- This is the content that will be projected -->
							<div items>
								<h5 class="text-info" style="line-height: normal; margin-bottom: 0;">
									{{filter.email}}</h5>
							</div>
						</ng-template>
					</app-input-autocomplete>
					</div>	
				</div>
				<div class="form-group">
					<label for="description" class="form-label">Descripción <i class="fa fa-asterisk text-danger"></i></label>
					<textarea name="description" [(ngModel)]="newCompanyRequest.description" placeholder="Ingresa información importante para la reunión" id="description" class="form-control"></textarea>
				</div>
				<div class="form-group">
					<label for="date" class="form-label">Fecha y hora <i class="fa fa-asterisk text-danger"></i></label>
					<input type="datetime-local" [(ngModel)]="tempDate" (change)="seeDate($event)" name="date" id="date" class="form-control">
				</div>
			</div>
			<div class="col">
				<h5>Fotos de referencia <i class="fa fa-asterisk text-danger"></i></h5>
				<section class="scrollport">
					<div class="add-photo" (click)="fileInput.click()">
						<i class="fa fa-circle-plus"></i>
					</div>
					<div *ngFor="let photo of photos; let i = index" style="background-image: url({{photo}});"
						(click)="photos.splice(i,1)">
						<div class="icon">
							<i class="fa fa-trash icon text-danger"></i>
						</div>
					</div>
				</section>
			</div>
		</div>
		<input #fileInput type="file" accept="image/*" multiple (change)="onFileChange($event,fileInput)"
			style="display: none;">
	</div>
	<div buttons>
		<app-loading-button [object]="buttonSave" [disabled]="getDisabledGeneral() || this.newCompany.activities.length == 0
		|| this.newCompany.contacts.length == 0
		|| this.newCompany.phones.length == 0
		|| this.photos.length == 0
		|| !this.newCompanyRequest.description
		|| !this.newCompanyRequest.date
		|| !this.newCompanyRequest.userId" (clicked)="saveRequest()"></app-loading-button>
	</div>
</app-simple-modal>